var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSmallClose = function SvgIconSmallClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 54 54"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EB008C",
    strokeWidth: 3.5,
    d: "m13.258 13.612 26.87 26.87M40.128 13.258l-26.87 26.87"
  })));
};
export default SvgIconSmallClose;